<template>
  <v-dialog eager v-model="dialog" max-width="400">
    <div class="valore-edit">
      <v-card>
        <div class="header navy white--text">
          <div v-if="context == 'calciatore'" class="title">
            Modifica costo {{ nomeCalciatore }}
          </div>
          <div v-else class="title">Modifica crediti {{ nomeSquadra }}</div>
          <v-btn @click="dismiss" icon small class="mr-2 white--text">
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <div class="body d-flex justify-center align-center ma-5">
          <v-btn
            fab
            depressed
            x-small
            class="yellow darken-2 white--text ma-2"
            @click="decrease"
            ><v-icon class="white--text">remove</v-icon></v-btn
          >

          <div class="valore">{{ valore }}</div>
          <v-btn
            fab
            depressed
            x-small
            class="yellow darken-2 white--text ma-2"
            @click="increase"
            ><v-icon class="white--text">add</v-icon></v-btn
          >
        </div>

        <div class="actions">
          <v-divider></v-divider>
          <div class="d-flex justify-center">
            <v-btn
              rounded
              depressed
              class="navy white--text ma-2"
              @click="salva"
              >Salva</v-btn
            >
          </div>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Vuex from "vuex";
import db from "../../js/db";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Constants from "../../js/constants";

export default {
  name: "valore-edit",
  mixins: [mixins, toast],
  data() {
    return {
      context: null,
      dialog: null,
      id_calciatore: null,
      id_squadra: null,
      valoreOld: null,
      valore: null,
    };
  },
  mounted() {
    db.on("showEditValore", this.show);
  },
  destroyed() {
    db.off("showEditValore", this.show);
  },
  props: {},

  computed: {
    nomeCalciatore() {
      if (this.calciatori[this.id_calciatore]) {
        return this.calciatori[this.id_calciatore].calciatore;
      }
      return "";
    },
    nomeSquadra() {
      if (this.squadra_) {
        return this.squadra_.name;
      }
      return "";
    },
    squadra_() {
      return this.squadra(this.id_squadra);
    },
    maxValue() {
      if (this.squadra_) {
        if (this.context == "calciatore") {
          return this.squadra_.max_offerta + this.valoreOld;
        } else {
          return 1000;
        }
      }
      return null;
    },
    minValue() {
      if (this.context == "calciatore") {
        return Constants.OFFERTA.MINIMA;
      } else {
        return 0;
      }
    },
    ...Vuex.mapGetters(["calciatori", "asta_squadre"]),
  },

  methods: {
    salva() {
      if (!this.valore || this.valoreOld == this.valore) {
        Swal.fire({
          icon: "warning",
          html: "Non hai impostato un valore diverso da prima",
        });
        return;
      }
      if (this.context == "calciatore") {
        db.modificaCalciatoreAssegnato(
          this.id_calciatore,
          this.id_squadra,
          this.valore
        )
          .then(
            this.astaLogEdit(
              this.id_calciatore,
              this.id_squadra,
              this.valore,
              this.valoreOld
            )
          )
          .then(this.dismiss());
      } else {
        let delta = this.valore - this.valoreOld;
        let crediti_extra_old =
          this.asta_squadre[this.id_squadra].crediti_extra;
        let crediti_extra = crediti_extra_old + delta;
        db.setCreditiExtra(this.id_squadra, crediti_extra)
          .then(
            this.astaLogCreditiExtra(
              this.id_squadra,
              this.valore,
              this.valoreOld,
              crediti_extra
            )
          )
          .then(this.dismiss());
      }
    },
    increase() {
      let _valore = this.valore + 1;
      let msg = "";
      msg =
        this.context == "calciatore"
          ? "Non puoi impostare più dell'offerta massima di questa squadra: " +
            this.maxValue
          : "Non puoi impostare più di " + this.maxValue;
      if (_valore > this.maxValue) {
        Swal.fire({
          icon: "warning",
          html: msg,
        });
      } else {
        this.valore = _valore;
      }
    },
    decrease() {
      let valore = this.valore - 1;
      let msg = "";
      msg =
        this.context == "calciatore"
          ? "Non puoi impostare meno dell'offerta minima impostata in quest'asta: " +
            this.minValue
          : "Non puoi impostare meno di " + this.minValue;
      if (valore < this.minValue) {
        Swal.fire({
          icon: "warning",
          html: msg,
        });
      } else {
        this.valore = valore;
      }
    },
    show(id_squadra, valore, id_calciatore) {
      this.context = id_calciatore ? "calciatore" : "squadra";
      this.id_calciatore = id_calciatore;
      this.id_squadra = id_squadra;
      this.valore = valore;
      this.valoreOld = valore;
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.context = null;
        this.id_calciatore = null;
        this.id_squadra = null;
        this.valore = null;
        this.valoreOld = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../main.scss";
.valore {
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  margin: 0 15px;
}
</style>

